import React from 'react'
import Counter from '../../elements/Counter'
// IMAGES
import imageReset from '../../../images/reset.png'

const LoyaltyCard = ({ _subtractCardFidelity, _addCardFidelity, _deleteCardFidelity, countCardLoyalty, keyUid, id, profil }) => {
    return (
        <div className='row mt-3 shadow'>
            <div className='card-body text-center'> 

                {profil.filter(p => p.id === 'profil' && p.cardLoyalty === true).map(p => (
                    <div key={p.id}>

                        <Counter 
                            title='Carte de fidélité' 
                            _substract={() => _subtractCardFidelity(countCardLoyalty, keyUid, id, p.countCardLoyalty)}
                            _add={() => _addCardFidelity(countCardLoyalty, keyUid, id, p.countCardLoyalty)}
                            counter={countCardLoyalty}
                            limit={countCardLoyalty.toString() === p.countCardLoyalty.toString()}
                        />

                        {/* REMOVE LOYALTY CARD */}
                        {countCardLoyalty.toString() === p.countCardLoyalty.toString() && 
                            <div className='text-center mt-2'>
                                
                                <div onClick={() => _deleteCardFidelity(countCardLoyalty, keyUid, id, p.countCardLoyalty)} style={{cursor:'pointer'}}>
                                <span><img src={imageReset} alt='reset' style={{ height:25, width:25, marginRight:'0.5rem' }} /></span>remettre à zéro
                                </div>
                            </div>
                        }

                    </div>
                ))}

            </div>
        </div>
    )
}

export default LoyaltyCard


